define('shared/remote/payment/adyen/constructSessionPayload',[
    'Promise',
    'shared/util/state',
    'shared/page/apiVersion',
    'shared/my/identity',
    'shared/my/cmus',
    'shared/page/language',
    'shared/page/market',
    'shared/page/partner',
    'shared/page/eTag'
], function (
    Promise,
    state,
    getAPIVersion,
    getIdentity,
    getCMus,
    getLanguage,
    getMarket,
    getPartner,
    getETag
) {

    function newHouse(offers) {
        return Promise.all([
            getLanguage(),
            getMarket(),
            getPartner(),
            getETag()
        ])
            .then(function(values){
                var language = values[0];
                var market = values[1];
                var partner = values[2];
                var etag = values[3];

                return {
                    PurchaseInfo: {
                        'Country': market,
                        'Partner': partner,
                        'Etag': etag,
                        'Channel': 'Online',
                        'Offer_ids': offers
                    },
                    AdyenInfo: {
                        'SdkVersion': '1.9.2',
                        'ReturnUrl': window.location.origin + window.location.pathname,
                        'Origin': window.location.origin,
                        'Language': language
                    }
                };
            });
    }

    function oldHouse(offers) {
        return Promise.all([
            getIdentity(),
            getCMus(),
            getMarket(),
            getPartner(),
            getETag()
        ])
            .then(function(values){
                var memberId = values[0];
                var cmus = values[1];
                var market = values[2];
                var partner = values[3];
                var etag = values[4];

                return {
                    'cmus': cmus,
                    'memberId': memberId,
                    'country': market,
                    'partner': partner,
                    'etag': etag,
                    'gatewayType': 'AdyenEL',
                    'offerIds': offers,
                    'extraInfo': {
                        'adyenOrigin': window.location.origin,
                        'adyenSdkVersion': '1.9.2',
                        'returnUrl': window.location.origin + window.location.pathname,
                        'adyenBlockedPaymentMethods': 'sepa'
                    }
                };
            });
    }

    return function (offers) {
        return getAPIVersion()
            .then(function(apiVersion){
                if (apiVersion === 'new-house') {
                    return newHouse(offers);
                } else {
                    return oldHouse(offers);
                }
            });
    };
});

